import React, { useState } from 'react';

const BatchPhaseDropdown = ({value,handleChange ,imp}) => {
    const [selectedPhase, setSelectedPhase] = useState('Created');

    return (
        <div >
            <label htmlFor="batch-phase" className="block text-gray-700 text-sm font-semibold  mb-2">
                Batch Phase &nbsp;{imp&&<span className='text-red-600'>*</span>}
            </label>
            <select
                id="batch-phase"
                value={value}
                onChange={handleChange}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"   
                >
                <option value='' disabled>Select Phase</option>
                <option value="Created">Created</option>
                <option value="In Progress">In Progress</option>
                <option value="Ready for Assesment">Ready for Assesment</option>
                <option value="Under Assesment">Under Assessment</option>
                <option value="Assesment Completed">Assessment Completed</option>
                <option value="Placement Completed">Placement Completed</option>


            </select>
        </div>
    );
};

export default BatchPhaseDropdown;
